<div class="h-margin-tb--sm m-validation m-validation--wizard" [ngClass]="{'m-validation--danger': level=='danger', 'm-validation--success': level=='success'}">
    <minster-validation-message [id]="id" *ngFor="let message of messages" [message]="message"></minster-validation-message>
</div>
